export default __webpack_public_path__ + "static/media/autoconsumo-compartido-empresas.8c72722c.svg";